const getDefaultState = () => ({
  affiliates: {
    items: [],
    loading: false,
    error: false,
    noContent: false,
  },
  affiliate: {
    item: undefined,
    loading: false,
    error: false,
  },
  domains: {
    items: [],
    loading: false,
    error: false,
  },
  logo: {
    loading: false,
    error: false,
  },
  suppliers: {
    items: [],
    loading: false,
    error: false,
  },
  affiliateSuppliers: {
    items: [],
    loading: false,
    error: false,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/affiliate/defaultState.js